import { Form } from "devextreme-react";
import {
  AsyncRule,
  EmptyItem,
  Label,
  RequiredRule,
  SimpleItem,
} from "devextreme-react/form";
import DataSource from "devextreme/data/data_source";
import { cat, paymentStatus, paytTerm } from "../../data";
import { useDispatch, useSelector } from "react-redux";
import { hasPermission } from "../../../../../utils/hasPermission";
import { PERM } from "../../../../../utils/permissions";
import ProjectDropDownBox from "./ProjectDropDownButtonBox";
import { useCallback, useEffect, useRef, useState } from "react";
import axios from "axios";
import {
  updateAOSQuotNo,
  updateBasicInfo,
  updateCat,
  updateComment,
  updateCost,
  updateInvDate,
  updateInvNo,
  updateInvPlan,
  updateInvPlanedDate,
  updatePaytDate,
  updatePaytDescr,
  updatePaytNo,
  updatePaytPlanedDate,
  updatePaytTerm,
  updateProjComplDate,
  updateStatus,
  updateTaskComplDate,
} from "../Redux/payment";
import TwoDateBoxComponent from "./TwoDateBoxComponent";
import CustomStore from "devextreme/data/custom_store";
import styled from "styled-components";
import Validator from "devextreme/ui/validator";

const PaymentFormWrapper = styled.div`
  .dx-field-item-required-mark {
    color: red;
  }

  .dx-datebox-calendar .dx-dropdowneditor-icon::before {
    content: "\f026";
  }
`;

export default function PaymentForm(props) {
  // console.debug("[PaymentForm]");

  const {
    projectDropDownBoxRef,
    formPaymentRef,
    payment,
    // projComplDateChanged,
    // setProjComplDateChanged,
  } = props;

  const dispatch = useDispatch();

  //   const payment = useSelector((state) => state.payment);

  const workStartYearMonthRef = useRef(null);
  const workEndYearMonthRef = useRef(null);

  const userInfo = useSelector((state) => state.userInfo);
  const canEditSales = hasPermission(userInfo.permissions, PERM.SALES_MGMT_EDIT);

  // const [projComplDateChanged, setProjComplDateChanged] = useState(false);

  const [AOSQuotNoDataSource, setAOSQuotNoDataSource] = useState(null);
  // [R28]
  useEffect(async () => {
    if (payment.contrNo) {
      const result = await axios.get(
        `${process.env.REACT_APP_BECCO_API_URL}/api/salesMgmt/payt/paytStatus/AOSQuotNo/${payment.contrNo}`
      );

      setAOSQuotNoDataSource(
        new DataSource({
          store: {
            data: result.data,
            type: "array",
            key: "AOSQuotNo",
          },
        })
      );
    }
  }, [payment.contrNo]);

  const [paytDescrDataSource, setPaytDescrDataSource] = useState(null);
  // [R6]
  useEffect(async () => {
    if (payment.cat == "1") {
      // PF
      const result = await axios.get(
        `${process.env.REACT_APP_BECCO_API_URL}/api/salesMgmt/payt/paytStatus/paytDescr?cat=${payment.cat}`
      );

      setPaytDescrDataSource(
        new DataSource({
          store: {
            data: result.data,
            type: "array",
            key: "paytDescr",
          },
        })
      );
    }
  }, [payment.cat]);

  const validatePaymentNoCallback = async ({ value }) => {
    if (payment.contrNo && payment.cat) {
      if (payment.action == "insert") {
        const result = await axios.get(
          `${process.env.REACT_APP_BECCO_API_URL}/api/salesMgmt/payt/paytStatus/chkPaytNo/${payment.contrNo}?quotNo=${payment.quotNo}&cat=${payment.cat}&paytNo=${value}`
        );

        return new Promise((resolve) => {
          setTimeout(() => {
            resolve(result.data.count == 0);
          }, 1000);
        });
      }
    } else {
      return false;
    }
  };
  const onPaytDescrCustomItemCreating = (args) => {
    if (!args.text) {
      args.customItem = null;

      return;
    }

    const newItem = {
      paytDescr: args.text,
    };

    args.customItem = paytDescrDataSource
      .store()
      .insert(newItem)
      .then(() => paytDescrDataSource.load())
      .then(() => newItem)
      .catch((error) => {
        throw error;
      });
  };

  const onCatValueChanged = (e) => {
    if (e.value) {
      dispatch(updateCat({ cat: e.value }));
    }
  };

  const onAOSQuotNoValueChanged = (e) => {
    dispatch(
      updateAOSQuotNo({
        AOSQuotNo: e.value ? e.value : null,
      })
    );
  };

  const onPaytNoValueChanged = (e) => {
    dispatch(
      updatePaytNo({
        paytNo: e.value ? e.value : null,
      })
    );
  };

  const onPaytDescrValueChanged = (e) => {
    dispatch(
      updatePaytDescr({
        paytDescr: e.value ? e.value : null,
      })
    );
  };

  const onCostExclVATValueChanged = (e) => {
    dispatch(
      updateCost({
        costExclVAT: e.value ? e.value : null,
      })
    );
  };

  const onInvNoValueChanged = (e) => {
    dispatch(
      updateInvNo({
        invNo: e.value ? e.value : null,
      })
    );
  };

  const onInvPlanValueChanged = (e) => {
    dispatch(
      updateInvPlan({
        invPlan: e.value ? e.value : false,
      })
    );
  };

  const onInvPlannedDateValueChanged = (e) => {
    dispatch(
      updateInvPlanedDate({
        invPlanedDate: e.value ? e.value : null,
      })
    );

    if (e.value) {
      if (payment.paytTerm) {
        updatePaytPlanedDateValue(e.value, payment.paytTerm);
      }
    }
  };

  const onInvDateValueChanged = (e) => {
    dispatch(
      updateInvDate({
        invDate: e.value ? e.value : null,
      })
    );
  };

  const onPaytTermValueChanged = (e) => {
    dispatch(
      updatePaytTerm({
        paytTerm: e.value ? e.value : null,
      })
    );

    if (e.value) {
      if (payment.invPlanedDate) {
        updatePaytPlanedDateValue(payment.invPlanedDate, e.value);
      }
    }
  };

  const onPaytPlanedDateValueChanged = (e) => {
    dispatch(
      updatePaytPlanedDate({
        paytPlanedDate: e.value ? e.value : null,
      })
    );
  };

  const onPaytDateValueChanged = (e) => {
    dispatch(
      updatePaytDate({
        paytDate: e.value ? e.value : null,
      })
    );
  };

  const updatePaytPlanedDateValue = (_invPlanedDate, _paytTerm) => {
    const invPlanedDate = new Date(_invPlanedDate);

    if (_paytTerm < "5") {
      invPlanedDate.setDate(
        invPlanedDate.getDate() +
          parseInt(paytTerm.find((term) => term.id == _paytTerm).name)
      );

      dispatch(
        updatePaytPlanedDate({
          paytPlanedDate: invPlanedDate,
        })
      );
    } else {
      invPlanedDate.setMonth(invPlanedDate.getMonth() + 1);

      if (invPlanedDate.getDate() <= 15) {
        dispatch(
          updatePaytPlanedDate({
            paytPlanedDate: `${invPlanedDate.getFullYear()}-${
              invPlanedDate.getMonth() + 1
            }-15`,
          })
        );
      } else {
        dispatch(
          updatePaytPlanedDate({
            paytPlanedDate: `${invPlanedDate.getFullYear()}-${
              invPlanedDate.getMonth() + 1
            }-${_paytTerm == 5 ? 30 : 31}`,
          })
        );
      }
    }
  };

  const onProjComplDateValueChanged = (e) => {
    dispatch(
      updateProjComplDate({
        projComplDate: e.value ? e.value : null,
      })
    );

    // setProjComplDateChange/d(true);
  };

  const onTaskComplDateValueChanged = (e) => {
    dispatch(
      updateTaskComplDate({
        taskComplDate: e.value ? e.value : null,
      })
    );
  };

  const onCommentValueChanged = (e) => {
    dispatch(
      updateComment({
        comment: e.value ? e.value : null,
      })
    );
  };

  const onStatusValueChanged = (e) => {
    dispatch(
      updateStatus({
        status: e.value ? e.value : null,
      })
    );
  };

  return (
    <PaymentFormWrapper>
      <Form
        id="form-payment"
        ref={formPaymentRef}
        colCount={4}
        labelMode="outside"
        labelLocation="top"
        showColonAfterLabel={true}
        style={{
          padding: "16px",
        }}
        validationGroup="paymentData"
      >
        <SimpleItem
          dataField={"cat"}
          editorType={"dxSelectBox"}
          editorOptions={{
            dataSource: cat,
            valueExpr: "id",
            displayExpr: "name",
            value: payment.cat,
            showClearButton: true,
            readOnly: !canEditSales ? true : false,
            onValueChanged: onCatValueChanged,
          }}
        >
          <Label text={"Category"} />
          <RequiredRule message={"Category is required."} />
        </SimpleItem>
        <SimpleItem dataField={"contrNo"}>
          <Label text={"Contract No."} />
          <ProjectDropDownBox
            type={"payment"}
            projectDropDownBoxRef={projectDropDownBoxRef}
            // payment={payment}
            data={payment}
            updateBasicInfo={updateBasicInfo}
          />
          <RequiredRule message={"Contract No. is required."} />
        </SimpleItem>
        <SimpleItem
          dataField={"sprName"}
          editorType={"dxTextBox"}
          editorOptions={{
            value: payment.sprName,
            readOnly: true,
          }}
        >
          <Label text={"Company Name"} />
        </SimpleItem>
        <SimpleItem
          dataField={"quotNo"}
          editorType={"dxTextBox"}
          editorOptions={{
            value: payment.quotNo,
            readOnly: true,
          }}
        >
          <Label text={"Quotation No."} />
        </SimpleItem>
        <SimpleItem
          dataField={"AOSQuotNo"}
          visible={payment.cat == "2" ? true : false}
          editorType={"dxSelectBox"}
          editorOptions={{
            dataSource: AOSQuotNoDataSource,
            displayExpr: "AOSQuotNo",
            valueExpr: "AOSQuotNo",
            value: payment.AOSQuotNo,
            showClearButton: true,
            readOnly: !canEditSales ? true : false,
            searchEnabled: true,
            searchMode: "contains",
            onValueChanged: onAOSQuotNoValueChanged,
          }}
        >
          <Label text={"AOS Quotation No."} />
          <RequiredRule message={"AOS Quotation No. is required."} />
        </SimpleItem>
        {payment.cat != 3 && (
          <SimpleItem
            name="paytNo"
            dataField={"paytNo"}
            editorType={"dxNumberBox"}
            editorOptions={{
              value: payment.paytNo,
              inputAttr: {
                style: "text-align : right",
              },
              showClearButton: true,
              readOnly: !canEditSales ? true : false,
              onValueChanged: onPaytNoValueChanged,
            }}
            isRequired={true}
          >
            <Label text={"Payment No."} />
            <RequiredRule message={"Payment No. is required."} />
            <AsyncRule
              message={"Payment number already exists."}
              validationCallback={validatePaymentNoCallback}
            />
          </SimpleItem>
        )}
        {
          payment.cat == 2 && (
            // (userInfo.div == "MW" ||
            //   userInfo.div == "CO" ||
            //   userInfo.div == "DM" ||
            //   userInfo.div == "SA" ||
            //   userInfo.div == "RA") && (
            <SimpleItem dataField={"workPeriod"}>
              <Label text={"Work Period"} />
              <TwoDateBoxComponent
                firstDateBox={{
                  field: "workStartYearMonth",
                  value: payment.workStartYearMonth,
                  ref: workStartYearMonthRef,
                }}
                secondDateBox={{
                  field: "workEndYearMonth",
                  value: payment.workEndYearMonth,
                  ref: workEndYearMonthRef,
                }}
              />
            </SimpleItem>
          )
          // )
        }
        {/* {payment.cat == 2 &&
          !(
            userInfo.div == "MW" ||
            userInfo.div == "CO" ||
            userInfo.div == "DM" ||
            userInfo.div == "SA" ||
            userInfo.div == "RA"
          ) && <EmptyItem />} */}
        {payment.cat == 2 && <EmptyItem />}
        {payment.cat == 1 && (
          <SimpleItem
            dataField={"paytDescr"}
            colSpan={3}
            editorType="dxSelectBox"
            editorOptions={{
              dataSource: paytDescrDataSource,
              displayExpr: "paytDescr",
              valueExpr: "paytDescr",
              acceptCustomValue: true,
              value: payment.paytDescr,
              showClearButton: true,
              readOnly: !canEditSales ? true : false,
              onValueChanged: onPaytDescrValueChanged,
              onCustomItemCreating: onPaytDescrCustomItemCreating,
            }}
          >
            <Label text={"Payment Description"} />
            <RequiredRule message={"Payment description is required."} />
          </SimpleItem>
        )}
        {payment.cat == 2 && (
          <SimpleItem
            dataField={"paytDescr"}
            colSpan={4}
            editorType={"dxTextArea"}
            editorOptions={{
              value: payment.paytDescr,
              showClearButton: true,
              readOnly: !canEditSales ? true : false,
              onValueChanged: onPaytDescrValueChanged,
            }}
          >
            <Label text={"Payment Description"} />
            <RequiredRule message={"Payment description is required."} />
          </SimpleItem>
        )}
        {payment.cat == 3 && (
          <SimpleItem
            dataField={"paytDescr"}
            colSpan={4}
            editorType={"dxTextBox"}
            editorOptions={{
              value: payment.paytDescr,
              showClearButton: true,
              readOnly: !canEditSales ? true : false,
              onValueChanged: onPaytDescrValueChanged,
            }}
          >
            <Label text={"Payment Description"} />
            <RequiredRule message={"Payment description is required."} />
          </SimpleItem>
        )}

        <SimpleItem
          dataField={"costExclVAT"}
          editorType={"dxNumberBox"}
          editorOptions={{
            value: payment.costExclVAT,
            format: "#,##0",
            inputAttr: {
              style: "text-align : right",
            },
            showClearButton: true,
            readOnly: !canEditSales ? true : false,
            onValueChanged: onCostExclVATValueChanged,
          }}
        >
          <Label text={"Cost (Excl.VAT)"} />
        </SimpleItem>
        <SimpleItem
          dataField={"costInclVAT"}
          editorType={"dxNumberBox"}
          editorOptions={{
            value: payment.costInclVAT,
            readOnly: true,
            format: "#,###",
            inputAttr: {
              style: "text-align : right",
            },
            showClearButton: true,
          }}
        >
          <Label text={"Cost (Incl.VAT)"} />
        </SimpleItem>
        {payment.cat == 1 && payment.action == "update" && (
          <SimpleItem
            dataField={"projComplDate"}
            editorType={"dxDateBox"}
            editorOptions={{
              value: payment.projComplDate,
              displayFormat: "yyyy-MM-dd",
              dateSerializationFormat: "yyyy-MM-dd",
              showClearButton: true,
              useMaskBehavior: true,
              readOnly: canEditSales ? true : false,
              onValueChanged: onProjComplDateValueChanged,
            }}
          >
            <Label text={"업무 완료 예정일"} />
          </SimpleItem>
        )}
        {payment.cat == 1 && payment.action == "update" && (
          <SimpleItem
            dataField={"taskComplDate"}
            editorType={"dxDateBox"}
            editorOptions={{
              value: payment.taskComplDate,
              displayFormat: "yyyy-MM-dd",
              dateSerializationFormat: "yyyy-MM-dd",
              showClearButton: true,
              readOnly: canEditSales ? true : false,
              onValueChanged: onTaskComplDateValueChanged,
            }}
          >
            <Label text={"업무 완료일"} />
          </SimpleItem>
        )}
        {(payment.action == "insert" || payment.cat != 1) && <EmptyItem />}
        {(payment.action == "insert" || payment.cat != 1) && <EmptyItem />}
        <SimpleItem
          dataField={"invNo"}
          editorType={"dxTextBox"}
          editorOptions={{
            value: payment.invNo,
            showClearButton: true,
            readOnly: !canEditSales ? true : false,
            onValueChanged: onInvNoValueChanged,
          }}
        >
          <Label text={"Invoice No."} />
          {/* <TextBox value={payment.invNo} onValueChanged={onInvNoValueChanged} /> */}
        </SimpleItem>
        {/* {payment.cat == 1 && payment.action == "update" && (
          <SimpleItem
            dataField={"invPlan"}
            editorType={"dxCheckBox"}
            editorOptions={{
              value: payment.invPlan
                ? payment.invPlan == 1
                  ? true
                  : false
                : false,
              text: "Hold",
              readOnly: !canEditSales ? true : false,
              onValueChanged: onInvPlanValueChanged,
            }}
          >
            <Label text={"Invoice Plan"} />
          </SimpleItem>
        )} */}
        <SimpleItem
          dataField={"invPlanedDate"}
          editorType={"dxDateBox"}
          editorOptions={{
            value: payment.invPlanedDate,
            displayFormat: "yyyy-MM-dd",
            dateSerializationFormat: "yyyy-MM-dd",
            showClearButton: true,
            useMaskBehavior: true,
            readOnly: !canEditSales ? true : false,
            onValueChanged: onInvPlannedDateValueChanged,
          }}
        >
          <Label text={"Invoice Planed Date"} />
        </SimpleItem>
        <SimpleItem
          dataField={"invDate"}
          editorType={"dxDateBox"}
          editorOptions={{
            value: payment.invDate,
            displayFormat: "yyyy-MM-dd",
            dateSerializationFormat: "yyyy-MM-dd",
            showClearButton: true,
            useMaskBehavior: true,
            readOnly: !canEditSales ? true : false,
            onValueChanged: onInvDateValueChanged,
          }}
        >
          <Label text={"Invoice Date"} />
        </SimpleItem>
        <SimpleItem
          dataField={"status"}
          editorType={"dxSelectBox"}
          editorOptions={{
            dataSource: paymentStatus,
            displayExpr: "name",
            valueExpr: "id",
            value: payment.status,
            showClearButton: true,
            readOnly: !canEditSales ? true : false,
            onValueChanged: onStatusValueChanged,
          }}
        >
          <Label text={"Payment Status"} />
          <RequiredRule message={"Payment status is required."} />
        </SimpleItem>
        {/* {(payment.action == "insert" || payment.cat != 1) && <EmptyItem />} */}
        <SimpleItem
          dataField={"paytTerm"}
          colSpan={2}
          editorType={"dxSelectBox"}
          editorOptions={{
            dataSource: paytTerm,
            displayExpr: "name",
            valueExpr: "id",
            value: payment.paytTerm,
            showClearButton: true,
            readOnly: !canEditSales ? true : false,
            onValueChanged: onPaytTermValueChanged,
          }}
        >
          <Label text={"Payment Term"} />
        </SimpleItem>
        <SimpleItem
          dataField={"paytPlanedDate"}
          editorType={"dxDateBox"}
          editorOptions={{
            value: payment.paytPlanedDate,
            displayFormat: "yyyy-MM-dd",
            dateSerializationFormat: "yyyy-MM-dd",
            showClearButton: true,
            useMaskBehavior: true,
            readOnly: !canEditSales ? true : false,
            onValueChanged: onPaytPlanedDateValueChanged,
          }}
        >
          <Label text={"Payment Planed Date"} />
        </SimpleItem>
        <SimpleItem
          dataField={"paytDate"}
          editorType={"dxDateBox"}
          editorOptions={{
            value: payment.paytDate,
            displayFormat: "yyyy-MM-dd",
            dateSerializationFormat: "yyyy-MM-dd",
            showClearButton: true,
            useMaskBehavior: true,
            readOnly: !canEditSales ? true : false,
            onValueChanged: onPaytDateValueChanged,
          }}
        >
          <Label text={"Payment Date"} />
          {/* <DateBox
          value={payment.paytDate}
          displayFormat={"yyyy-MM-dd"}
          dateSerializationFormat="yyyy-MM-dd"
          onValueChanged={onPaytDateValueChanged}
        /> */}
        </SimpleItem>
        {(payment.updateFields.includes("projComplDate") ||
          payment.updateFields.includes("taskComplDate")) && (
          <SimpleItem
            dataField={"comment"}
            editorType={"dxTextBox"}
            editorOptions={{
              value: payment.comment,
              showClearButton: true,
              onValueChanged: onCommentValueChanged,
            }}
            colSpan={4}
          >
            <Label text={"Comment"} />
            <RequiredRule
              message={
                "A comment must be added whenever the due date (업무완료예정일) is changed."
              }
            />
          </SimpleItem>
        )}
      </Form>
    </PaymentFormWrapper>
  );
}
